/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The KeyDate window to collect. Omit both to use the window the cycle derives: everything since the previous cycle, or since the authorization was submitted for the first one.
 * @export
 * @interface ExternalEmrDocumentPullRequest
 */
export interface ExternalEmrDocumentPullRequest {
    /**
     * YYYY-MM-DD, inclusive.
     * @type {string}
     * @memberof ExternalEmrDocumentPullRequest
     */
    key_date_start?: string;
    /**
     * YYYY-MM-DD, inclusive. 422 when it is in the future.
     * @type {string}
     * @memberof ExternalEmrDocumentPullRequest
     */
    key_date_end?: string;
}

/**
 * Check if a given object implements the ExternalEmrDocumentPullRequest interface.
 */
export function instanceOfExternalEmrDocumentPullRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalEmrDocumentPullRequestFromJSON(json: any): ExternalEmrDocumentPullRequest {
    return ExternalEmrDocumentPullRequestFromJSONTyped(json, false);
}

export function ExternalEmrDocumentPullRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocumentPullRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key_date_start': !exists(json, 'key_date_start') ? undefined : json['key_date_start'],
        'key_date_end': !exists(json, 'key_date_end') ? undefined : json['key_date_end'],
    };
}

export function ExternalEmrDocumentPullRequestToJSON(value?: ExternalEmrDocumentPullRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key_date_start': value.key_date_start,
        'key_date_end': value.key_date_end,
    };
}

